webpackJsonp([580],{

/***/ 1063:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  head: { "title": " | VUX - Vue 移动端 UI 组件库", "ignoreSuffixChar": "|" }
});

/***/ }),

/***/ 2017:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(67)(
  /* script */
  __webpack_require__(1063),
  /* template */
  __webpack_require__(2773),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/data/vux/home/websites/vux-repo/docs/node_modules/v-markdown-loader/_cache/components_layout-4.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] components_layout-4.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5a5d5382", Component.options)
  } else {
    hotAPI.reload("data-v-5a5d5382", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ 2773:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("layout")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Divider_COM")]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/divider/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/divider"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/divider",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Divider.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Divider } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("default")])]), _vm._v(" "), _c('td', [_vm._v("title")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/divider"
    }
  }, [_vm._v("Demo page")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Grid_COM")]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/grid/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/grid"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/grid",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Grid.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Grid, GridItem } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-component-name"
  }, [_vm._v("Grid")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("rows")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("3")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.2.0")])]), _vm._v(" "), _c('td', [_vm._v("(deprecated after v2.6.0) the number of rows. Less than 5 will be better")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("cols")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("3")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.6.1")])]), _vm._v(" "), _c('td', [_vm._v("the number of columns. if there is more than one row in grid, need to set cols value, otherwise all grid items will show in one row with the same width")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("show-lr-borders")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.8.1")])]), _vm._v(" "), _c('td', [_vm._v("whether show left and right borders")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("show-vertical-dividers")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.8.1")])]), _vm._v(" "), _c('td', [_vm._v("whether show vertical dividers")])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("default")])]), _vm._v(" "), _c('td', [_vm._v("default slot for "), _c('code', [_vm._v("grid-item")]), _vm._v(" list")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-component-name"
  }, [_vm._v("GridItem")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("icon")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("icon url. if using local resources, it is better to use "), _c('code', [_vm._v("slot=icon")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("label")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_c('code', [_vm._v("label")]), _vm._v(" text")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("link")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("vue-router’s path")])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("icon")])]), _vm._v(" "), _c('td', [_vm._v("icon slot, use "), _c('code', [_vm._v("<img>")])]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("label")])]), _vm._v(" "), _c('td', [_vm._v("slot for label, the same func as prop:label")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/grid"
    }
  }, [_vm._v("Demo page")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Scroller_COM")]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/scroller/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/scroller"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/scroller",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Scroller.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Scroller } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("value")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-object"
  }, [_vm._v("Object")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("current pulldown and pullup status, use "), _c('code', [_vm._v("v-model")]), _vm._v(" for binding")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("height")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("viewport height")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("scroller’s height, you can use "), _c('code', [_vm._v("height=-40")]), _vm._v(" to make scroller set to height: "), _c('code', [_vm._v("viewportHeight - 40px")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("lock-x")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("lock the horizontal direction")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("lock-y")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("lock the vertical direction")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("scrollbar-x")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if show horizontal scrollbar")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("scrollbarY")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if show vertical scrollerbar")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("bounce")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if use bounce effect")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("use-pulldown")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if use pulldown plugin")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("use-pullup")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if use pullup plugin")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("pulldown-config")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-object"
  }, [_vm._v("Object")])]), _vm._v(" "), _c('td', [_vm._v("see below")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("config for pulldown plugin")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("pullup-config")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-object"
  }, [_vm._v("Object")])]), _vm._v(" "), _c('td', [_vm._v("see below")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("config for pullup plugin")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("scroll-bottom-offset")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("0")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.2.1-rc.6")])]), _vm._v(" "), _c('td', [_vm._v("where to emit event:on-scroll-bottom before reaching bottom")])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("default")])]), _vm._v(" "), _c('td', [_vm._v("scroller content, should has only one "), _c('code', [_vm._v("div")]), _vm._v(" root")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Events")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-scroll")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("(position)")])]), _vm._v(" "), _c('td', [_vm._v("emits when user scrolls")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-scroll-bottom")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("emits when user scrolls to bottom. The event may emit multiple times, so you should use a variable for keeping status if you need fetching data")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.2.1-rc.6")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-pulldown-loading")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("emits when scroller is on pulldown-loading status")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-pullup-loading")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("emits when scroller is on pullup-loading status")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Methods")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("reset")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("(position, duration, easing)")])]), _vm._v(" "), _c('td', [_vm._v("reset scroller to reset height whenever your data is changed. easing can be one of ease-in, ease-in-out, ease, bezier(n, n, n, n)")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("donePullup")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("set pullup done after new data is fetched")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("disablePullup")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("disable pullup plugin when there is no more data")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("enablePullup")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("enable pullup plugin")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("donePulldown")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("set pulldown done after new data is fetched")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/scroller"
    }
  }, [_vm._v("Demo page")])]), _vm._v(" "), _c('p', [_vm._v("pulldown 默认配置:")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("{\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("content")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'Pull Down To Refresh'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("height")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("60")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("autoRefresh")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-literal"
  }, [_vm._v("false")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("downContent")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'Pull Down To Refresh'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("upContent")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'Release To Refresh'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("loadingContent")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'Loading...'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("clsPrefix")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'xs-plugin-pulldown-'")]), _vm._v("\n}\n")])]), _vm._v(" "), _c('p', [_vm._v("pullup 默认配置:")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("{\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("content")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'Pull Up To Refresh'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("pullUpHeight")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("60")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("height")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("40")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("autoRefresh")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-literal"
  }, [_vm._v("false")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("downContent")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'Release To Refresh'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("upContent")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'Pull Up To Refresh'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("loadingContent")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'Loading...'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("clsPrefix")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'xs-plugin-pullup-'")]), _vm._v("\n}\n")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-qa"
  }, [_vm._v("QA 如何更新数据")])]), _vm._v(" "), _c('p', [_vm._v("如果展示内容只是简单的增加或者减少，直接调用"), _c('code', [_vm._v("reset")]), _vm._v("方法即可")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("this")]), _vm._v(".$nextTick("), _c('span', {
    staticClass: "hljs-function"
  }, [_c('span', {
    staticClass: "hljs-params"
  }, [_vm._v("()")]), _vm._v(" =>")]), _vm._v(" {\n  "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("this")]), _vm._v(".$refs.scroller.reset()\n})\n")])]), _vm._v(" "), _c('p', [_vm._v("如果展示内容完全重载，那么需要主动设置位置让其能正确回到顶部。适用于改变筛选条件后重载数据的情况")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("this")]), _vm._v(".$nextTick("), _c('span', {
    staticClass: "hljs-function"
  }, [_c('span', {
    staticClass: "hljs-params"
  }, [_vm._v("()")]), _vm._v(" =>")]), _vm._v(" {\n  "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("this")]), _vm._v(".$refs.scroller.reset({\n    "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("top")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("0")]), _vm._v("\n  })\n})\n")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-qa"
  }, [_vm._v("QA 如何设置pullup完成")])]), _vm._v(" "), _c('p', [_vm._v("方法1，直接调用ref的"), _c('code', [_vm._v("donePullup")]), _vm._v("方法")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("this")]), _vm._v(".$refs.demo2.donePullup()\n")])]), _vm._v(" "), _c('p', [_vm._v("方法2，绑定value, 重置状态")]), _vm._v(" "), _c('p', {
    staticClass: "tip"
  }, [_vm._v("自定义pullup模板同样是用v-model来绑定以获取状态变化")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("scroller")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("v-model")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"status\"")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("scroller")]), _vm._v(">")]), _vm._v("\n")])]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("data () {\n  "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("return")]), _vm._v(" {\n    "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("status")]), _vm._v(": {\n      "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("pullupStatus")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'default'")]), _vm._v("\n    }\n  }\n}\n")])]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("// 重置状态为default\nthis.status.pullupStatus = 'default\n")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-qa"
  }, [_vm._v("QA 如何设置pulldown完成")])]), _vm._v(" "), _c('p', [_vm._v("参照"), _c('code', [_vm._v("pullup")]), _vm._v(", 使用方法"), _c('code', [_vm._v("donePulldown")]), _vm._v("或者绑定"), _c('code', [_vm._v("pulldownStatus")]), _vm._v("然后重置为"), _c('code', [_vm._v("default")]), _vm._v("。")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-qa"
  }, [_vm._v("QA 如何禁用或者启用pullup")])]), _vm._v(" "), _c('p', [_vm._v("在有些情况下，比如数据不多不需要上拉加载或者已经加载完成，我们需要禁用pullup"), _c('br'), _vm._v("\n同样可以调用方法 "), _c('code', [_vm._v("disablePullup")]), _vm._v(" 或者设置"), _c('code', [_vm._v("pullupStatus")]), _vm._v("为"), _c('code', [_vm._v("disabled")])]), _vm._v(" "), _c('p', [_vm._v("反之，则调用方法 "), _c('code', [_vm._v("enablePullup")]), _vm._v(" 或者设置"), _c('code', [_vm._v("pullupStatus")]), _vm._v("为"), _c('code', [_vm._v("enabled")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-qa"
  }, [_vm._v("启用keep-alive后滚动有问题")])]), _vm._v(" "), _c('p', [_vm._v("需要在调用Scroller的页面上在 hook: "), _c('code', [_vm._v("activated")]), _vm._v("上执行"), _c('code', [_vm._v("reset")])]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("activated () {\n  "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("this")]), _vm._v(".$refs.scroller.reset()\n}\n")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Sticky_COM")]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/sticky/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/sticky"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/sticky",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Sticky.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Sticky } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("scroll-box")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("window")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("scroll tagget")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("check-sticky-support")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if check if sticky is supported on current browser")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("offset")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("0")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("top distance")])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("default")])]), _vm._v(" "), _c('td', [_vm._v("content")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Methods")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("bindSticky")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("manually re-bind sticky")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.5.4")])])])])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/sticky"
    }
  }, [_vm._v("Demo page")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("ViewBox_COM")]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/view-box/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/view-box"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/view-box",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/ViewBox.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { ViewBox } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("body-padding-top")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("undefined")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("body-padding-bottom")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("undefined")])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("header")])]), _vm._v(" "), _c('td', [_vm._v("undefined")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("default")])]), _vm._v(" "), _c('td', [_vm._v("undefined")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("bottom")])]), _vm._v(" "), _c('td', [_vm._v("undefined")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Methods")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("scrollTo")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("(top)")])]), _vm._v(" "), _c('td', [_vm._v("undefined")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("getScrollTop")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("undefined")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("getScrollBody")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("undefined")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/view-box"
    }
  }, [_vm._v("Demo page")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("XHeader_COM")]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/x-header/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/x-header"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/x-header",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/XHeader.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { XHeader } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("left-options.showBack")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if show back text")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("left-options.backText")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("Back")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("the back text")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("left-options.preventGoBack")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("stop go back when clicking")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("title")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("title")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("transition")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("title transition")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("right-options.showMore")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if show more icon")])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("default")])]), _vm._v(" "), _c('td', [_vm._v("title")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("left")])]), _vm._v(" "), _c('td', [_vm._v("left slot after backText")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("overwrite-left")])]), _vm._v(" "), _c('td', [_vm._v("overwrite left icon and text")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.2.2")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("right")])]), _vm._v(" "), _c('td', [_vm._v("right slot")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("overwrite-title")])]), _vm._v(" "), _c('td', [_vm._v("overwrite title content")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.5.3")])])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Events")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-click-more")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("triggers when more icon is clicked")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-click-back")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("triggers when left part is clicked and the prop ‘left-options.preventGoBack’ is true")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-click-title")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("triggers when title is clicked")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/x-header"
    }
  }, [_vm._v("Demo page")])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5a5d5382", module.exports)
  }
}

/***/ }),

/***/ 559:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(2017);

/***/ })

});


// WEBPACK FOOTER //
// 580.b3cd0c2e.js